import { useEffect, useState } from "react";
import { track } from "../lib/analytics";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { fetchArticles } from "../lib/api";

import { ArrowUpRight } from "lucide-react";

export default function BlogSection() {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    let tries = 0;
    const load = () =>
      fetchArticles()
        .then(setArticles)
        .catch(() => {
          if (tries++ < 4) setTimeout(load, 1500 * tries);
          else setArticles([]);
        });
    load();
  }, []);

  return (
    <section id="guides" className="py-24 md:py-32" data-testid="blog-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-16">
          <Reveal>
            <p className="text-sm uppercase tracking-[0.25em] font-bold text-[#C85A40] mb-4">Learn the ropes</p>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight text-[#1A1714] max-w-xl mx-auto">
              Guides that make insurance click
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-testid="guides-grid">
          {articles === null &&
            [0, 1, 2].map((i) => (
              <div key={i} className="animate-pulse" data-testid="guide-skeleton">
                <div className="h-56 rounded-2xl bg-[#EAE3D9]" />
                <div className="mt-5 h-3 w-24 rounded bg-[#EAE3D9]" />
                <div className="mt-3 h-6 w-3/4 rounded bg-[#EAE3D9]" />
                <div className="mt-3 h-4 w-full rounded bg-[#EAE3D9]" />
              </div>
            ))}
          {articles && articles.length === 0 && (
            <p className="text-[#4A453F]" data-testid="guides-empty">Guides are loading slowly. Please refresh the page.</p>
          )}
          {(articles || []).map((a, i) => (
            <Reveal key={a.id} delay={i * 0.08}>
              <Link
                to={`/guides/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                onClick={() => track("guide_link_click", { guide: a.slug, location: "guides" })}
                className="group block h-full"
              >
                <div className="overflow-hidden rounded-2xl mb-5">
                  <img
                    src={a.image}
                    alt={a.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#C85A40]">
                  {a.category} · {a.read_time}
                </p>
                <h3 className="mt-2 font-display text-2xl tracking-tight text-[#1A1714] group-hover:text-[#C85A40] transition-colors">
                  {a.title}
                </h3>
                <p className="mt-2 text-[#4A453F] leading-relaxed">{a.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-[#1E3A2F] font-semibold text-sm">
                  Read guide <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
